/* eslint-disable global-require */
module.exports = ['customer._left_menu.m2', 'message.index.m4', 'message.index.m2', 'message.index.m1', 'routes.marketplace_message_action'];
